import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '@components/shared/ScrollToTop';
import clsx from 'clsx';

export default function Layout() {
    const { sidebarCollapsed } = useSelector((state) => state.ui);
    const location = useLocation();
    const isKarsilama = location.pathname === '/';

    // Karşılama sayfasında sidebar, header, footer gizlenir
    if (isKarsilama) {
        return (
            <div className="min-h-screen">
                <ScrollToTop />
                <Outlet />
            </div>
        );
    }

    return (
        <div className="flex flex-col min-h-screen bg-bg-primary">
            <ScrollToTop />
            <Sidebar />
            <Header />

            <main
                className={clsx(
                    'flex-1 pt-[var(--header-height)] transition-all duration-300',
                    // Desktop margin
                    'ml-0 md:ml-[var(--sidebar-collapsed-width)]',
                    !sidebarCollapsed && 'md:ml-[var(--sidebar-width)]'
                )}
            >
                <div className="p-4 md:p-6 min-h-[calc(100vh-var(--header-height)-56px)]">
                    <Outlet />
                </div>
            </main>

            <div
                className={clsx(
                    'transition-all duration-300',
                    'ml-0 md:ml-[var(--sidebar-collapsed-width)]',
                    !sidebarCollapsed && 'md:ml-[var(--sidebar-width)]'
                )}
            >
                <Footer />
            </div>
        </div>
    );
}
